/** @jsx jsx */
import { jsx } from "@emotion/react";
import { FC, useState } from "react";
import { OptionalizeKeys } from "../../../../globalTypes";
import Dropzone, { DropzoneProps } from "./Dropzone";
import FileList, { FileListProps } from "./FileList";

export type Props = OptionalizeKeys<DropzoneProps, "pasteListenerTarget"> &
  FileListProps;

const FlowioFileDropzone: FC<Props> = ({
  files,
  onDelete,
  pasteListenerTarget,
  ...rest
}) => {
  const [containerRef, setContainerRef] = useState<HTMLDivElement | null>(null);

  return (
    <div ref={setContainerRef}>
      <Dropzone
        {...rest}
        pasteListenerTarget={pasteListenerTarget ?? containerRef}
      />
      <FileList files={files} onDelete={onDelete} />
    </div>
  );
};

export default FlowioFileDropzone;
export type FlowioFileDropzoneProps = Props;
